import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { BiChevronDown, BiPlus } from "react-icons/bi";
import PatientMedicineServiceModal from "./PatientMedicineServiceModal";
import { Button, Input, Select } from "../Form";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllMedicamentos,
  getMedicamentos,
} from "../../redux/features/recetaSlice";
import { apiUrl } from "../../redux/apiUrl";
import axios from "axios";

const presentaciones = [
  { id: 0, name: "Ninguno" },
  { id: 1, name: "Crema" },
  { id: 2, name: "Cremas" },
  { id: 3, name: "Gel" },
  { id: 4, name: "Geles" },
  { id: 5, name: "Suero" },
  { id: 6, name: "Sueros" },
  { id: 7, name: "Loción" },
  { id: 8, name: "Lociones" },
  { id: 9, name: "Champú" },
  { id: 10, name: "Champús" },
  { id: 11, name: "Tableta" },
  { id: 12, name: "Tabletas" },
  { id: 13, name: "Cápsula" },
  { id: 14, name: "Cápsulas" },
  { id: 15, name: "Comprimido" },
  { id: 16, name: "Comprimidos" },
  { id: 17, name: "Jarabe" },
  { id: 18, name: "Jarabes" },
  { id: 19, name: "Gotas" },
  { id: 20, name: "Frasco" },
  { id: 21, name: "Frascos" },
  { id: 22, name: "Tubo" },
  { id: 23, name: "Tubos" },
  { id: 24, name: "Unidad" },
];

function MedicineDosageModal({ closeModal, isOpen, setReceta }) {
  const [open, setOpen] = useState(false);
  const [instraction, setInstraction] = useState({ name: "Ninguno" });
  const [presentacion, setPresentacion] = useState(presentaciones[0]);
  const [cantidad, setCantidad] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [instructionsData, setInstructionsData] = useState([]);
  const [filteredInstrucciones, setFilteredInstrucciones] = useState([]);
  const [instruccionTexto, setInstruccionTexto] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nombre: "",
      cantidad: "",
      instraction: "",
    },
  });
  const dispatch = useDispatch();
  const medicamentos = useSelector(getAllMedicamentos);

  useEffect(() => {
    setInstraction(watch("instraction"));
    dispatch(getMedicamentos());
  }, [dispatch, medicamentos.length]);

  useEffect(() => {
    const fetchInstrucciones = async () => {
      const { data } = await axios.get(`${apiUrl}/api/v1/instrucciones`);

      const instruccionesModificadas = data.map((param) => {
        return {
          id: param.id,
          name: param.name,
          selected: false,
        };
      });
      instruccionesModificadas.unshift({ name: "Ninguno" });
      setInstructionsData(instruccionesModificadas);
    };
    fetchInstrucciones();
  }, []);

  const handleAgregar = (body) => {
    // Obtener todos los valores del formulario
    const formValues = getValues();

    setReceta((prevReceta) => [
      ...prevReceta,
      {
        nombre: formValues.nombre,
        instrucciones: formValues.instraction, // Corregido el nombre del campo
        presentacion: presentacion.name,
        cantidad: formValues.cantidad,
      },
    ]);
    closeModal();
  };
  const handleChange = (e) => {
    // String() por si algún medicamento quedó cargado con un nombre numérico (rompía el filtro).
    let filtered = medicamentos.filter((item) =>
      String(item?.name ?? "").toLowerCase().includes(String(e.target.value ?? "").toLowerCase())
    );
    if (filtered.length > 10) filtered = filtered.slice(0, 10);

    if (e.target.value.length === 0) {
      setFilteredData(medicamentos.slice(0, 10));
    } else setFilteredData(filtered);
  };

  // Sugerencias de instrucciones: mismo criterio que Medicamento (máx. 10 para no colgar la página).
  // OJO: hay instrucciones cargadas con un número como nombre (ej. 1, 76004567). Sin String() de por
  // medio, item.name.toLowerCase() reventaba y no se mostraba NINGUNA sugerencia.
  const buscarInstrucciones = (texto) => {
    const q = String(texto ?? "").toLowerCase().trim();
    const base = instructionsData.filter(
      (i) => i?.name != null && String(i.name).trim() !== "" && i.name !== "Ninguno"
    );
    const filtered = q.length === 0
      ? base
      : base.filter((item) => String(item.name).toLowerCase().includes(q));
    setFilteredInstrucciones(filtered.slice(0, 10));
  };
  return (
    <>
      {open && (
        <PatientMedicineServiceModal
          closeModal={() => setOpen(!open)}
          isOpen={open}
          patient={false}
        />
      )}
      <Modal
        closeModal={closeModal}
        isOpen={isOpen}
        title="Agregar Medicamento a Prescripción"
        width={"max-w-xl"}
      >
        <div className="flex-colo gap-6">
          {/* title */}
          <div className="w-full">
            <Input
              label="Medicamento"
              color={true}
              register={register("nombre", {
                required: "Introduzca el nombre.",
                onChange: (e) => handleChange(e),
                onBlur: () => setFilteredData([]),
                onMouseDown: (e) => handleChange(e),
              })}
              type={"text"}
              error={errors.nombre}
            />

            {filteredData?.length > 0 && (
              <ul className="max-h-40 w-full sm:w-1/2 border absolute  rounded-lg z-50 bg-white overflow-y-scroll">
                {filteredData?.map((item) => (
                  <li
                    key={item.id}
                    onMouseDown={() => {
                      setValue("nombre", item.name);
                      setTimeout(setFilteredData([]), 400);
                    }}
                    className="border-b py-2 px-5"
                  >
                    {`${item.name}`}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Instrucciones: mismo buscador que Medicamento. Antes era un desplegable que pintaba las
              ~4.900 instrucciones de golpe y colgaba la página. Ahora sugiere mientras se escribe
              (máx. 10) y se puede escribir una nueva que no esté registrada. */}
          <div className="w-full relative">
            <label className="text-black text-sm">Instrucciones</label>
            <textarea
              rows={3}
              placeholder="Escribí para buscar o redactá una instrucción nueva"
              value={instruccionTexto}
              onChange={(e) => {
                const v = e.target.value;
                setInstruccionTexto(v);
                setValue("instraction", v);
                buscarInstrucciones(v);
              }}
              onFocus={() => buscarInstrucciones(instruccionTexto)}
              className="focus:border-subMain placeholder-colorPlaceholder w-full bg-transparent text-sm mt-3 p-4 border border-border rounded font-light"
            />
            {filteredInstrucciones?.length > 0 && (
              <ul className="max-h-40 w-full border absolute left-0 right-0 rounded-lg z-50 bg-white overflow-y-auto shadow-lg">
                {filteredInstrucciones.map((item, i) => (
                  <li
                    key={item.id ?? i}
                    onMouseDown={(e) => {
                      e.preventDefault(); // sin esto el blur cierra la lista antes del clic
                      setInstruccionTexto(item.name);
                      setValue("instraction", item.name);
                      setFilteredInstrucciones([]);
                    }}
                    className="border-b py-2 px-5 text-sm hover:bg-greyed cursor-pointer"
                  >
                    {item.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="flex w-full flex-col gap-3">
            <p className="text-black text-sm">Presentación</p>
            <Select
              selectedPerson={presentacion}
              setSelectedPerson={setPresentacion}
              datas={presentaciones}
            >
              <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                {presentacion.name} <BiChevronDown className="text-xl" />
              </div>
            </Select>
          </div>
          <Input
            label="Cantidad"
            color={true}
            register={register("cantidad", {
              required: "Introduzca la cantidad.",
              min: { value: 1, message: "La cantidad debe ser mayor a 0" },
            })}
            type={"number"}
            error={errors.cantidad}
          />

          <Button
            onClick={handleSubmit(handleAgregar)}
            label="Agregar"
            Icon={BiPlus}
          />
        </div>
      </Modal>
    </>
  );
}

export default MedicineDosageModal;
